import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    hideCartAddedNotification,
    type CartAddedNotificationPayload,
} from '../../actions/cartActions.ts';

type CartStore = {
    cart: {
        cartAddedNotification: CartAddedNotificationPayload | null;
    };
};

export function useCartAddedNotification(): {
    notification: CartAddedNotificationPayload | null;
    onClose: () => void;
} {
    const dispatch = useDispatch();
    const notification = useSelector(
        (state: CartStore) => state.cart?.cartAddedNotification || null
    );
    const onClose = useCallback((): void => {
        dispatch(hideCartAddedNotification());
    }, [dispatch]);

    return { notification, onClose };
}
